import { memo } from 'react';

import { ErrorIcon } from './ErrorIcon';
import styles from './Fallback.module.scss';

interface DefaultErrorProps {
  onRetry: () => void;
}

/**
 * CategoryWidget 의 내장 default fallback.
 *
 * 호스트가 `fallback` prop 으로 override 안 한 경우 표시.
 * generic message + retry 버튼. 에러 종류별 분기는 호스트가 fallback prop 으로.
 *
 * @see plan/category-widget-design.md — Q8 (내장 default), Q14 (분기는 호스트 책임)
 */
export const Fallback = memo(function DefaultError({ onRetry }: DefaultErrorProps) {
  return (
    <div className={styles.fallback} role="alert">
      <div className={styles.content}>
        <ErrorIcon />
        <div className={styles.message}>
          <span>카테고리를 불러 오지 못했어요.</span>
          <span>다시시도를 눌러주세요</span>
        </div>
      </div>
      <button className={styles.retryButton} onClick={onRetry} type="button">
        다시시도
      </button>
    </div>
  );
});
